<template>
  <section class="component-b910a4bd" resmed-component-name="blog-tags">
    <div class="component">
      <div class="container text-center">
        <eyebrow-icon
          v-bind:eyebrowicon="{ color: 'black', icon: 'tag' }"
          v-bind:align="'center'"
        ></eyebrow-icon>
        <h2>Tags</h2>
        <ul>
          <li v-for="(tag, index) in tags">
            <a v-bind:href="`${address}?tags=${index}`">{{ tag }}</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-b910a4bd", // blog-tags
  props: ["tags"],
  data() {
    return {
      address: "/sleep-apnea/sleep-blog/",
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b910a4bd {
  padding: 5rem 0;
}

.component {
  h2 {
    position: relative;
    @extend %eyebrow-center;

    // &:after {
    //     content: '';
    //     width: 100%;
    //     position: absolute;
    //     top: -6.25rem;
    //     left: 0;
    //     border-top: 1px solid $cc-resmed-grey-15;
    // }
  }

  ul {
    @extend %body-small-bold;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    li {
      a {
        position: relative;
        margin-right: 0.75rem;
        padding-right: 0.75rem;
        display: inline-block;

        &:hover {
          text-decoration: underline;
        }

        &:before {
          display: block;
          content: "";
          position: absolute;
          height: 0.75rem;
          width: 2px;
          top: 0.25rem;
          right: 0;
          background-color: $cc-resmed-grey-30;
        }
      }

      &:last-child {
        a {
          &:before {
            display: none;
          }
        }
      }
    }
  }
}
</style>